import { createFileRoute } from "@tanstack/react-router";

import { ConsoleOverviewPage, consoleOverviewQueryOptions } from "@/features/console";

export const Route = createFileRoute("/_authed/_modal/console/")({
  // Intent preload — fire-and-forget, never blocks navigation.
  loader: ({ context: { queryClient } }) => {
    void queryClient.ensureQueryData(consoleOverviewQueryOptions());
  },
  component: ConsoleOverviewPage,
});
